<script setup lang="ts">
import { onMounted } from 'vue';
import KpGrossverbraucherHeaderSelect from './KpGrossverbraucherHeaderSelect.vue';
import { ZuordnungImportHeaderCollection } from '@/models/ZuordnungImportHeader';
import type { SelectChangeEvent } from 'primevue/select';

defineProps<{
    csvHeaders: any[];
    jahr?: number | null;
    kantonId?: number | null;
}>();

export type SelectionChangeEvent = {
    zuordnungImportHeaderId: number | null;
    headerVariableId: number | null;
};

const gvCollection: ZuordnungImportHeaderCollection = new ZuordnungImportHeaderCollection();
const gvEvCollection: ZuordnungImportHeaderCollection = new ZuordnungImportHeaderCollection();
const gvWbCollection: ZuordnungImportHeaderCollection = new ZuordnungImportHeaderCollection();
const gvWaCollection: ZuordnungImportHeaderCollection = new ZuordnungImportHeaderCollection();

defineEmits<{
    (e: 'selectionChange', value: SelectionChangeEvent): void;
}>();

onMounted(async () => {
    gvCollection.setQueryParams({
        filter: [
            {
                id: 'target_tabelle',
                property: 'target_tabelle',
                value: 'grossverbraucher',
            },
        ],
    });
    gvEvCollection.setQueryParams({
        filter: [
            {
                id: 'target_tabelle',
                property: 'target_tabelle',
                value: 'grossverbraucher_energieverbrauch',
            },
        ],
    });
    gvWbCollection.setQueryParams({
        filter: [
            {
                id: 'target_tabelle',
                property: 'target_tabelle',
                value: 'grossverbraucher_waermebezug',
            },
        ],
    });
    gvWaCollection.setQueryParams({
        filter: [
            {
                id: 'target_tabelle',
                property: 'target_tabelle',
                value: 'grossverbraucher_waermeabgabe',
            },
        ],
    });
    gvCollection.query();
    gvEvCollection.query();
    gvWbCollection.query();
    gvWaCollection.query();
});
</script>

<template>
    <div>
        <h4>{{ $t('grossverbraucher') }}</h4>
    </div>
    <div v-for="model in gvCollection.getModels()" :key="model.id ?? 'new'" class="formgrid grid">
        <div class="field col-12 md:col-5 align-self-center text-right">{{ model.anzeige_name }}</div>
        <div class="field col-12 md:col-5">
            <KpGrossverbraucherHeaderSelect
                :header-model="model"
                :options="csvHeaders"
                @change="
                    (option: SelectChangeEvent) =>
                        $emit('selectionChange', { zuordnungImportHeaderId: model.id, headerVariableId: option.value })
                "
            ></KpGrossverbraucherHeaderSelect>
        </div>
    </div>
    <div>
        <h4>{{ $t('energieverbrauch') }}</h4>
    </div>
    <div v-for="model in gvEvCollection.getModels()" :key="model.id ?? 'new'" class="formgrid grid">
        <div class="field col-12 md:col-5 align-self-center text-right">{{ model.anzeige_name }}</div>
        <div class="field col-12 md:col-5">
            <KpGrossverbraucherHeaderSelect
                :header-model="model"
                :options="csvHeaders"
                @change="
                    (option: SelectChangeEvent) =>
                        $emit('selectionChange', { zuordnungImportHeaderId: model.id, headerVariableId: option.value })
                "
            ></KpGrossverbraucherHeaderSelect>
        </div>
    </div>
    <div>
        <h4>{{ $t('waermebezug') }}</h4>
    </div>
    <div v-for="model in gvWbCollection.getModels()" :key="model.id ?? 'new'" class="formgrid grid">
        <div class="field col-12 md:col-5 align-self-center text-right">{{ model.anzeige_name }}</div>
        <div class="field col-12 md:col-5">
            <KpGrossverbraucherHeaderSelect
                :header-model="model"
                :options="csvHeaders"
                @change="
                    (option: SelectChangeEvent) =>
                        $emit('selectionChange', { zuordnungImportHeaderId: model.id, headerVariableId: option.value })
                "
            ></KpGrossverbraucherHeaderSelect>
        </div>
    </div>
    <div>
        <h4>{{ $t('waermeabgabe') }}</h4>
    </div>
    <div v-for="model in gvWaCollection.getModels()" :key="model.id ?? 'new'" class="formgrid grid">
        <div class="field col-12 md:col-5 align-self-center text-right">{{ model.anzeige_name }}</div>
        <div class="field col-12 md:col-5">
            <KpGrossverbraucherHeaderSelect
                :header-model="model"
                :options="csvHeaders"
                @change="
                    (option: SelectChangeEvent) =>
                        $emit('selectionChange', { zuordnungImportHeaderId: model.id, headerVariableId: option.value })
                "
            ></KpGrossverbraucherHeaderSelect>
        </div>
    </div>
</template>
